import script from "./Parcel-Card.vue?vue&type=script&setup=true&lang=js"
export * from "./Parcel-Card.vue?vue&type=script&setup=true&lang=js"

import "./Parcel-Card.vue?vue&type=style&index=0&id=4393653a&lang=css"

const __exports__ = script;

export default __exports__